export default {
    title: 'Impostazioni',
    subtitle: 'Gestisci API keys e configurazioni dei servizi',
    loading: 'Caricamento impostazioni...',
    tabs: {
        apiKeys: 'API Keys',
        serviceConfigs: 'Servizi Esterni',
        preferences: 'Preferenze',
    },
    apiKeys: {
        title: 'API Keys',
        description: 'Gestisci le chiavi API per i servizi esterni',
        newKey: 'Nuova API Key',
        searchPlaceholder: 'Cerca per nome, servizio...',
        categoryPlaceholder: 'Filtra per categoria',
        allCategories: 'Tutte le categorie',
        headers: {
            name: 'Nome',
            service: 'Servizio',
            category: 'Categoria',
            type: 'Tipo',
            status: 'Stato',
            actions: 'Azioni',
        },
        status: {
            active: 'Attivo',
            inactive: 'Inattivo',
        },
        modal: {
            edit: 'Modifica API Key',
            new: 'Nuovo API Key',
            fields: {
                name: 'Nome',
                namePlaceholder: 'Nome della chiave',
                service: 'Servizio',
                servicePlaceholder: 'Nome del servizio',
                category: 'Categoria',
                type: 'Tipo',
                value: 'Valore',
                valuePlaceholder: 'Inserisci il valore della chiave',
                description: 'Descrizione',
                descriptionPlaceholder: 'Descrizione opzionale',
            },
        },
        actions: {
            edit: 'Modifica',
            delete: 'Elimina',
        },
    },
    serviceConfigs: {
        title: 'Servizi Esterni',
        description: 'Configurazioni per i servizi esterni',
        newService: 'Nuovo Servizio',
        searchPlaceholder: 'Cerca per nome...',
        categoryPlaceholder: 'Filtra per categoria',
        headers: {
            name: 'Nome',
            category: 'Categoria',
            baseUrl: 'Base URL',
            status: 'Stato',
            actions: 'Azioni',
        },
        modal: {
            edit: 'Modifica Servizio',
            new: 'Nuovo Servizio',
            fields: {
                name: 'Nome',
                namePlaceholder: 'Nome del servizio',
                category: 'Categoria',
                baseUrl: 'Base URL',
                baseUrlPlaceholder: 'https://api.example.com',
                config: 'Configurazione JSON',
                configPlaceholder: '{"key": "value"}',
            },
        },
        actions: {
            edit: 'Modifica',
            delete: 'Elimina',
        },
    },
    preferences: {
        language: {
            title: 'Lingua',
            description: 'Seleziona la lingua preferita per l\'interfaccia',
        },
        theme: {
            title: 'Tema',
            description: 'Scegli tra tema chiaro e scuro',
        },
    },
    modal: {
        cancel: 'Annulla',
        save: 'Salva Modifiche',
        create: 'Crea',
        confirmDelete: 'Sei sicuro di voler eliminare questo elemento?',
    },
};

